import { courseFromSpec, type Hole } from '@shared/course';
import type { PlayerPublic, RoomPublicState } from '@shared/protocol';

/** The client's view of the room. Everything here came from the server; nothing is guessed. */
export class ClientState {
  roomId = '';
  me: { id: string; token: string } | null = null;
  state: RoomPublicState | null = null;
  holes: Hole[] = [];
  private specKey = '';

  apply(state: RoomPublicState) {
    this.state = state;
    const key = `${state.spec.seed}:${state.spec.holes.length}`;
    if (key !== this.specKey) { this.holes = courseFromSpec(state.spec); this.specKey = key; }
  }
  get hole(): Hole | null {
    if (!this.state) return null;
    return this.holes[this.state.hole] ?? null;
  }
  get myPlayer(): PlayerPublic | null {
    if (!this.state || !this.me) return null;
    return this.state.players.find((p) => p.id === this.me!.id) ?? null;
  }
  get isMyTurn(): boolean {
    return !!this.state && !!this.me && this.state.turn === this.me.id && this.state.status !== 'finished';
  }
}

export function saveIdentity(roomId: string, me: { id: string; token: string }) {
  try { localStorage.setItem(`links:${roomId}`, JSON.stringify(me)); } catch { /* private mode */ }
}
export function loadIdentity(roomId: string): { id: string; token: string } | null {
  try { const s = localStorage.getItem(`links:${roomId}`); return s ? (JSON.parse(s) as { id: string; token: string }) : null; } catch { return null; }
}
export function playerName(): string {
  try {
    const n = localStorage.getItem('links:name');
    if (n) return n;
    const fresh = `Golfer ${Math.floor(100 + Math.random() * 900)}`;
    localStorage.setItem('links:name', fresh);
    return fresh;
  } catch { return 'Golfer'; }
}
